// Import model
import { FilterWasteFactorRequest } from '../models/FilterWasteFactorRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { WasteFactorCondition } from '../models/WasteFactorCondition';
import { WasteFactorFields } from '../models/WasteFactorFields';
import { WasteFactorIndexedFields } from '../models/WasteFactorIndexedFields';

// Import dependency serializers (for complex types)
import { WasteFactorConditionSerializer } from './WasteFactorConditionSerializer';
import { WasteFactorFieldsSerializer } from './WasteFactorFieldsSerializer';
import { WasteFactorIndexedFieldsSerializer } from './WasteFactorIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterWasteFactorRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterWasteFactorRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterWasteFactorRequest instance
   */
  static deserialize(json: string): FilterWasteFactorRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterWasteFactorRequest instance
   */
  static fromObject(obj: any): FilterWasteFactorRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterWasteFactorRequest');
    }


    const instance: FilterWasteFactorRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as WasteFactorIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as WasteFactorFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        WasteFactorConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterWasteFactorRequest instances
   */
  static deserializeArray(json: string): FilterWasteFactorRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterWasteFactorRequest instance to a JSON string
   */
  static serialize(instance: FilterWasteFactorRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterWasteFactorRequest instance to a plain object
   */
  static toObject(instance: FilterWasteFactorRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        WasteFactorConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterWasteFactorRequest instances to a JSON string
   */
  static serializeArray(instances: FilterWasteFactorRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
